define("Magento_Theme/js/theme",["jquery","mage/smart-keyboard-handler","mage/mage","domReady!"],function(e,a){"use strict";e(".panel.header > .header.links").clone().appendTo("#store\\.links"),a.apply()});
